import React from 'react';

import { FormData } from '../../types';
import { sanitizeSingleLineInput } from '../utils/sanitize';

interface StoreInfoFormProps {
  formData: FormData;
  onFormDataChange: (updates: Partial<FormData>) => void;
}

const StoreInfoForm: React.FC<StoreInfoFormProps> = ({
  formData,
  onFormDataChange,
}) => {
  return (
    <div className="form-section">
          <div style={{ marginBottom: 'var(--space-4)' }}>
            <label
              htmlFor="company"
              style={{
                display: 'block',
                marginBottom: 'var(--space-2)',
                fontWeight: '600',
                color: 'var(--color-text)',
              }}
            >
              Store Name
            </label>
            <input
              type="text"
              id="company"
              value={formData.company}
              onChange={(e) =>
                onFormDataChange({
                  company: sanitizeSingleLineInput(e.target.value),
                })
              }
              style={{
                width: '100%',
                padding: 'var(--space-3)',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius)',
                fontSize: '1rem',
                background: 'var(--color-input-bg)',
                color: '#000000',
                boxSizing: 'border-box',
              }}
              required
            />
          </div>
          <div style={{ marginBottom: 'var(--space-4)' }}>
            <label
              htmlFor="storeNumber"
              style={{
                display: 'block',
                marginBottom: 'var(--space-2)',
                fontWeight: '600',
                color: 'var(--color-text)',
              }}
            >
              Store Number
            </label>
            <input
              type="text"
              id="storeNumber"
              value={formData.storeNumber}
              onChange={(e) =>
                onFormDataChange({
                  storeNumber: sanitizeSingleLineInput(e.target.value),
                })
              }
              style={{
                width: '100%',
                padding: 'var(--space-3)',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius)',
                fontSize: '1rem',
                background: 'var(--color-input-bg)',
                color: '#000000',
                boxSizing: 'border-box',
              }}
              required
            />
          </div>
          <div style={{ marginBottom: 'var(--space-4)' }}>
            <label htmlFor="poNumber" style={{
              display: 'block',
              marginBottom: 'var(--space-2)',
              fontWeight: '600',
              color: 'var(--color-text)'
            }}>
              PO Number
            </label>
            <input
              type="text"
              id="poNumber"
              value={formData.poNumber || ''}
              onChange={(e) => onFormDataChange({ poNumber: sanitizeSingleLineInput(e.target.value) })}
              style={{
                width: '100%',
                padding: 'var(--space-3)',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius)',
                fontSize: '1rem',
                background: 'var(--color-input-bg)',
                color: '#000000',
                boxSizing: 'border-box'
              }}
              required
            />
          </div>
      <div style={{ marginBottom: 'var(--space-4)' }}>
        <label htmlFor="orderedBy" style={{ 
          display: 'block', 
          marginBottom: 'var(--space-2)', 
          fontWeight: '600',
          color: 'var(--color-text)'
        }}>
          Ordered By
        </label>
        <input
          type="text"
          id="orderedBy"
          value={formData.orderedBy}
          onChange={(e) => onFormDataChange({ orderedBy: sanitizeSingleLineInput(e.target.value) })}
          style={{
            width: '100%',
            padding: 'var(--space-3)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius)',
            fontSize: '1rem',
            background: 'var(--color-input-bg)',
            color: '#000000',
            boxSizing: 'border-box'
          }}
          required
        />
      </div>
      <div>
        <label htmlFor="date" style={{ 
          display: 'block', 
          marginBottom: 'var(--space-2)', 
          fontWeight: '600',
          color: 'var(--color-text)'
        }}>
          Date
        </label>
        <input
          type="date"
          id="date"
          value={formData.date}
          onChange={(e) => onFormDataChange({ date: e.target.value })}
          style={{
            width: '100%',
            padding: 'var(--space-3)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius)',
            fontSize: '1rem',
            background: 'var(--color-input-bg)',
            color: '#000000',
            boxSizing: 'border-box'
          }}
          required
        />
      </div>
    </div>
  );
};

export default StoreInfoForm;
